import { type Context, createContext, useContext } from 'react';
import type { TreeNodeData } from '../models';

export const NodeDataContext = createContext<Map<string, TreeNodeData>>(new Map());

export const useNodeDataMap = () => {
  const context = useContext<Map<string, TreeNodeData>>(
    NodeDataContext as unknown as Context<Map<string, TreeNodeData>>,
  );

  if (!context) {
    throw new Error('useNodeDataMap should be used inside a NodeDataContext provider');
  }

  return context;
};
